"use client";
import type { GameCardTranslations } from "@casino/shared/components/GameCard/translations";
import { useHoverData } from "./Context/HoverDataContext";
import DefaultHover from "./DefaultHover";
import DepositToPlay from "./DepositToPlay";

type Props = {
  game: GameFragment;
  gameHref: string;
  translations?: GameCardTranslations;
};

const Hover: FC<Props> = ({ game, gameHref, translations }) => {
  const { isDepositToPlay } = useHoverData(game.minBet ?? 0);
  if (isDepositToPlay) {
    return <DepositToPlay gameHref={gameHref} translations={translations} />;
  }
  return <DefaultHover />;
};

export default Hover;
